import React from 'react';
import FilterSidebar from './FilterSidebar';
import Fulltext from './fields/Fulltext';
import Radius from './fields/Radius';
import TagDropdown from './fields/TagDropdown';
import OpeningHours from './fields/OpeningHours';
import Tags from './fields/Tags';
import {useTranslation} from '../../config/TranslationProvider';

const LocationsFilter = ({tags, onSubmit, filter, fixedFilter}) => (
    <FilterSidebar
        forListing="locations"
        filters={{
            'fulltext': <Fulltext selected={filter.fulltext} />,
            'radius': <Radius selected={filter.radius} />,
            'tagDropdown': <TagDropdown selected={filter.tags} />,
            'openingHours': <OpeningHours selected={filter.opening_hours} />,
            'tags': <Tags tags={tags} selected={filter.tags} fixed={fixedFilter.tags} />,
        }}
        onSubmit={onSubmit}
        formDescription={useTranslation('locations_filter_form_description')}
    />
);

export default LocationsFilter;
